import axios from '../utils/ajax'
// 开卡付款
export const registerCard = params => axios.get('/managementPlatform/thailand/registerCard',{params})
// 续费付款
export const renewPay = params => axios.get('/managementPlatform/thailand/renewPay',{params})
// 查询开卡续费商品
export const queryRegisterCardCommodity = params => axios.get('/managementPlatform/thailand/queryRegisterCardCommodity',{
  params,
  // loading:true
})
// 查询续费商品
export const queryRenewPayCommodity = params => axios.get('/managementPlatform/thailand/queryRenewPayCommodity',{
  params,
  // loading:true
})
// 卡管理列表
export const queryCardInfoList = params => axios.get('/managementPlatform/thailand/queryCardInfoList',{
  params
})
// 卡管理详情
export const queryCardInfoDetail = params => axios.get('/managementPlatform/thailand/queryCardInfoDetail',{
  params
})
// 切换凭证状态
export const chargeVoucherStatus = params => axios.get('/managementPlatform/thailand/chargeVoucherStatus',{
  params
})
// 编辑卡信息
export const editContactInfo = params => axios.get('/managementPlatform/thailand/editAccountInfo',{
  params
})
// 用户：
// 用户查询列表
export const queryUserAccount = params => axios.get('/managementPlatform/thailand/queryUserAccount',{
  params
})

// 用户新增
export const addOrEditUserAccount = params => axios.get('/managementPlatform/thailand/addOrEditUserAccount',{
  params
})

// 分配用户
export const distributeUserAccount = params => axios.get('/managementPlatform/thailand/distributeUserAccount',{
  params
})

// 移出用户
export const removeUser = params => axios.get('/managementPlatform/thailand/removeUser',{
  params
})

// 修改权限编号
export const editUnitMemberAuthorityScheme = params => axios.get('/managementPlatform/thailand/editUnitMemberAuthorityScheme',{
  params
})


// 权限方案下拉
export const queryAllAuthorityScheme = params => axios.post('/managementPlatform/authority/queryAllAuthorityScheme',{
  params
})
// 修改密码
export const editAccountPassword = params => axios.get('/managementPlatform/thailand/editAccountPassword',{
  params
})

// 卡解绑用户
export const cardUnbindingUser = params => axios.post('/managementPlatform/thailand/cardUnbindingUser',params)
// 卡绑定用户
export const cardBindingUser = params => axios.post('/managementPlatform/thailand/cardBindingUser',params)



// WEBPACK FOOTER //
// ./src/api/openCard.js